export enum Endpoint {
    PRODUCTS = '/gate/products',
    AVAILABILITY = '/gate/availability',
    AVAILABLE_PRODUCTS = '/gate/availability/products',
    AUTH = '/gate/auth',
    OPTIONS = '/gate/options',
    COMPANIONS = '/gate/companion-products',
    CONFIGURATION = '/gate/configuration',
    CHECKOUT = '/gate/checkouts',
    SELECTITEMS = '/gate/selectitems',
    CUSTOMER = '/gate/customer',
    VALIDATION = '/gate/validation',
}
